// Usage: PrefetchHelper.prefetchImages(["https://example.com/image.jpg", "https://example.com/image2.jpg"]);
class PrefetchHelper {
    static prefetchImages(imageUrls: string[]) {
        imageUrls.forEach((url) => {
            const link = document.createElement("link");
            link.rel = "prefetch";
            link.href = url;
            document.head.appendChild(link);
        });
    }
}

const extractDomain = (url) => {
    try {
        return new URL(url).origin;
    } catch (e) {
        return null;
    }
}

const addDnsPrefetch = () => {
    const urls = [
        process.env.VUE_APP_PAYJOY_STORE_LOCATOR_URL,
        process.env.VUE_APP_MIDDLEWARE_URL,
        process.env.VUE_APP_MIDDLEWARE_CALLBACK_URL
    ];

    urls
        .map(extractDomain)
        .filter(Boolean)
        .forEach(domain => {
            const link = document.createElement('link');
            link.rel = 'dns-prefetch';
            link.href = domain as string;
            document.head.appendChild(link);
        });
}

export {addDnsPrefetch};
export default PrefetchHelper;